
import React, { useEffect, useState } from "react";

const AddPeopleModal = ({ open, friends, existing, onCancel, onConfirm }) => {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (!open) setSelected([]);
  }, [open]);

  if (!open) return null;

  const toggleSelect = (u) => {
    setSelected(prev =>
      prev.includes(u.public_user_id)
        ? prev.filter(id => id !== u.public_user_id)
        : [...prev, u.public_user_id]
    );
  };

  return (
    <div className="msn-modal-backdrop">
      <div className="msn-modal">
        <div className="msn-modal-titlebar">Add People to Chat</div>
<div className="msn-modal-body">
  {friends.length === 0 ? (
    <p>No friends to add.</p>
  ) : (
    <div className="add-people-list">
      {friends.map(f => (
        <button
          type="button"
          key={f.public_user_id}
          className={`friend-select-item ${selected.includes(f.public_user_id) ? "active" : ""}`}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            toggleSelect(f);
          }}
          aria-pressed={selected.includes(f.public_user_id)}
        >
          <span>{f.username}</span>
          {selected.includes(f.public_user_id) && (
            <span className="friend-select-check" aria-hidden="true">✔</span>
          )}
        </button>
      ))}
    </div>
  )}
</div>
        <div className="msn-modal-actions">
          <button type="button" className="msn-btn xp-secondary" onClick={onCancel}>Cancel</button>
          <button
            type="button"
            className="msn-btn xp-primary"
            onClick={(event) => {
              event.preventDefault();
              onConfirm(selected);
            }}
            disabled={selected.length === 0}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPeopleModal;
